import { gql } from '@apollo/client/core'
import * as VueApolloComposable from '@vue/apollo-composable'
import type * as VueCompositionApi from 'vue'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export type ReactiveFunction<TParam> = () => TParam
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string }
}

/** Archived state filter for the notifications feed */
export enum ArchivedStatus {
  /** All notifications regardless of archived state */
  All = 'ALL',
  /** Only archived notifications */
  Archived = 'ARCHIVED',
  /** Only non-archived notifications */
  Visible = 'VISIBLE',
}

/** Unzer basket item type */
export enum BasketItemTypeEnum {
  /** Digital products */
  Digital = 'digital',
  /** Physical products */
  Goods = 'goods',
  /** Shipping fees */
  Shipment = 'shipment',
  /** Vouchers/gift cards */
  Voucher = 'voucher',
}

/** A single key/value pair inside a notification content block */
export type BlockField = {
  __typename?: 'BlockField'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

/** Card payment details */
export type CardPaymentInput = {
  /** Unzer payment type ID (created via frontend SDK for PCI compliance) */
  paymentTypeId: Scalars['String']['input']
}

/** Invoice information for checkout */
export type CheckoutInvoiceInput = {
  /** Optional note or reference text to show on the invoice */
  invoiceNote?: InputMaybe<Scalars['String']['input']>
  /** Invoice number (unique) */
  invoiceNumber: Scalars['String']['input']
  /** Invoice line items */
  lineItems: Array<InvoiceLineItemInput>
  /** Service period (Leistungszeitraum) */
  servicePeriod?: InputMaybe<ServicePeriodInput>
  /** Total amount including VAT */
  totalGross?: InputMaybe<Scalars['String']['input']>
  /** Total amount excluding VAT */
  totalNet?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of CheckoutMutation */
export type CheckoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Customer information */
  customer: CustomerInput
  /** Order information */
  order: OrderInput
  /** Payment method details */
  paymentMethod: PaymentMethodInput
}

/** Autogenerated return type of CheckoutMutation. */
export type CheckoutMutationPayload = {
  __typename?: 'CheckoutMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Mutation errors */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** URL to redirect for payment completion */
  redirectUrl?: Maybe<Scalars['String']['output']>
  /** Order status */
  status: OrderStatusEnum
  /** Whether the checkout was successful */
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CorrectionMutation */
export type CorrectionMutationInput = {
  billingCity: Scalars['String']['input']
  billingCountry: Scalars['String']['input']
  billingStreet: Scalars['String']['input']
  billingStreetAddition?: InputMaybe<Scalars['String']['input']>
  billingZip: Scalars['String']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  /** Purchase order number (PO number) */
  customerReference?: InputMaybe<Scalars['String']['input']>
  firstname: Scalars['String']['input']
  /** Note or reference text to show on the invoice */
  invoiceNote?: InputMaybe<Scalars['String']['input']>
  /** Debit invoice number to correct */
  invoiceNumber: Scalars['String']['input']
  lastname: Scalars['String']['input']
  /** Order reference */
  reference: Scalars['String']['input']
  /** Customer VAT identification number */
  vatId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CorrectionMutation. */
export type CorrectionMutationPayload = {
  __typename?: 'CorrectionMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Credit invoice number */
  creditInvoiceNumber?: Maybe<Scalars['String']['output']>
  /** Mutation errors */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** New debit invoice number */
  newInvoiceNumber?: Maybe<Scalars['String']['output']>
  /** Whether the correction was successful */
  success: Scalars['Boolean']['output']
}

/** Supported currency codes */
export enum CurrencyEnum {
  /** Euro */
  Eur = 'EUR',
}

/** Customer information for checkout */
export type CustomerInput = {
  /** Billing city */
  billingCity: Scalars['String']['input']
  /** Billing country (ISO 2-letter code) */
  billingCountry: Scalars['String']['input']
  /** Billing street address */
  billingStreet: Scalars['String']['input']
  /** Billing street addition (Adresszusatz) */
  billingStreetAddition?: InputMaybe<Scalars['String']['input']>
  /** Billing ZIP code */
  billingZip: Scalars['String']['input']
  /** Company name (optional) */
  company?: InputMaybe<Scalars['String']['input']>
  /** Purchase order number (PO number) */
  customerReference?: InputMaybe<Scalars['String']['input']>
  /** Customer email address */
  email: Scalars['String']['input']
  /** Customer first name */
  firstname: Scalars['String']['input']
  /** Customer last name */
  lastname: Scalars['String']['input']
  /** Preferred locale for invoices and emails (de or en) */
  preferredLocale?: InputMaybe<Scalars['String']['input']>
  /** Customer VAT identification number */
  vatId?: InputMaybe<Scalars['String']['input']>
}

/** Unzer Direct Debit payment details */
export type DirectDebitPaymentInput = {
  /** Customer birth date */
  birthDate: Scalars['ISO8601Date']['input']
  /** Account holder name */
  holder?: InputMaybe<Scalars['String']['input']>
  /** IBAN for SEPA Direct Debit */
  iban: Scalars['String']['input']
}

/** An invoice */
export type Invoice = {
  __typename?: 'Invoice'
  /** Gross amount (decimal as string) */
  amountGross: Scalars['String']['output']
  /** Net amount (decimal as string) */
  amountNet: Scalars['String']['output']
  /** VAT amount (decimal as string) */
  amountVat: Scalars['String']['output']
  billingCity: Scalars['String']['output']
  billingCountry: Scalars['String']['output']
  billingName: Scalars['String']['output']
  billingStreet: Scalars['String']['output']
  billingZip: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  invoiceType: Scalars['String']['output']
  /** True if this invoice is part of a correction pair (credit or new debit) */
  isCorrection: Scalars['Boolean']['output']
  issuedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lineItems: Array<InvoiceLineItem>
  note?: Maybe<Scalars['String']['output']>
  number: Scalars['String']['output']
  /** Download URL for the invoice PDF (nil if not yet generated) */
  pdfUrl?: Maybe<Scalars['String']['output']>
  priceBasis: Scalars['String']['output']
  status: Scalars['String']['output']
}

/** An invoice line item */
export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  /** Discount per unit (gross, decimal as string) */
  discountPerUnitGross?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  itemType: Scalars['String']['output']
  /** Line total after discount (gross, decimal as string) */
  lineTotalGross: Scalars['String']['output']
  quantity: Scalars['Int']['output']
  referenceId: Scalars['String']['output']
  title: Scalars['String']['output']
  /** Unit price before discount (gross, decimal as string) */
  unitPriceGross: Scalars['String']['output']
  /** VAT rate as percentage (e.g. "19.0") */
  vatRate: Scalars['String']['output']
}

/** Invoice line item details */
export type InvoiceLineItemInput = {
  /** Discount per unit (gross). Applied before calculating line total. */
  discountPerUnitGross?: InputMaybe<Scalars['String']['input']>
  /** Discount per unit (net). Applied before calculating line total. */
  discountPerUnitNet?: InputMaybe<Scalars['String']['input']>
  /** Unique line item identifier within invoice */
  externalId: Scalars['String']['input']
  /** Item type for Unzer basket (goods, shipment, voucher, digital) */
  itemType: BasketItemTypeEnum
  /** Line total gross AFTER discount: (unit_price_gross - discount_per_unit_gross) x qty */
  lineTotalGross?: InputMaybe<Scalars['String']['input']>
  /** Line total net AFTER discount: (unit_price_net - discount_per_unit_net) x qty */
  lineTotalNet?: InputMaybe<Scalars['String']['input']>
  /** Promo code applied to this line item */
  promoCode?: InputMaybe<Scalars['String']['input']>
  /** Quantity */
  quantity: Scalars['Int']['input']
  /** Product SKU */
  referenceId: Scalars['String']['input']
  /** Product name */
  title: Scalars['String']['input']
  /** Unit price BEFORE discount (including VAT) */
  unitPriceGross?: InputMaybe<Scalars['String']['input']>
  /** Unit price BEFORE discount (excluding VAT) */
  unitPriceNet?: InputMaybe<Scalars['String']['input']>
  /** VAT rate (e.g., 19.0, 7.0, 0.0) */
  vatRate: Scalars['String']['input']
}

/** Result of the markAllAsRead mutation */
export type MarkAllAsReadPayload = {
  __typename?: 'MarkAllAsReadPayload'
  /** Count of unread, visible notifications after the operation */
  unreadCount: Scalars['Int']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Process checkout with Unzer payment integration */
  checkout?: Maybe<CheckoutMutationPayload>
  /** Correct an issued debit invoice by creating a credit note and a new debit invoice */
  correctInvoice?: Maybe<CorrectionMutationPayload>
  public: PublicMutation
  /** Refund line items from a debit invoice via Unzer cancel */
  refund?: Maybe<RefundMutationPayload>
  /** Resend an issued invoice to the customer email currently stored on the order */
  resendInvoice?: Maybe<ResendInvoiceMutationPayload>
  /** Update the customer email for an order's customer */
  updateCustomerEmail?: Maybe<UpdateCustomerEmailMutationPayload>
}

export type MutationCheckoutArgs = {
  input: CheckoutMutationInput
}

export type MutationCorrectInvoiceArgs = {
  input: CorrectionMutationInput
}

export type MutationRefundArgs = {
  input: RefundMutationInput
}

export type MutationResendInvoiceArgs = {
  input: ResendInvoiceMutationInput
}

export type MutationUpdateCustomerEmailArgs = {
  input: UpdateCustomerEmailMutationInput
}

/** A user-facing notification */
export type Notification = {
  __typename?: 'Notification'
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  category: Scalars['String']['output']
  content: Array<NotificationBlock>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  partnerCompanySlug?: Maybe<Scalars['String']['output']>
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  schemaVersion: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  uuid: Scalars['String']['output']
}

/** A typed content block inside a notification (header, cta, tag, ...) */
export type NotificationBlock = {
  __typename?: 'NotificationBlock'
  fields: Array<BlockField>
  type: Scalars['String']['output']
}

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection'
  /** Distinct categories across the current user feed, ignoring active filters */
  availableCategories: Array<Scalars['String']['output']>
  /** A list of edges. */
  edges: Array<NotificationEdge>
  /** A list of nodes. */
  nodes: Array<Notification>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total count of items */
  totalCount: Scalars['Int']['output']
  /** Count of unread, visible notifications for the current user */
  unreadCount: Scalars['Int']['output']
}

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Notification>
}

export type NotificationMutations = {
  __typename?: 'NotificationMutations'
  /** Archives the given notifications for the current user */
  archive: Array<Notification>
  /** Marks all visible unread notifications as read for the current user */
  markAllAsRead: MarkAllAsReadPayload
  /** Marks the given notifications as read for the current user */
  markAsRead: Array<Notification>
  /** Marks the given notifications as unread for the current user */
  markAsUnread: Array<Notification>
  /** Unarchives the given notifications for the current user */
  unarchive: Array<Notification>
}

export type NotificationMutationsArchiveArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type NotificationMutationsMarkAsReadArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type NotificationMutationsMarkAsUnreadArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type NotificationMutationsUnarchiveArgs = {
  ids: Array<Scalars['ID']['input']>
}

/** An order */
export type Order = {
  __typename?: 'Order'
  /** Balance (decimal as string) */
  balance: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  currency: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoices: Array<Invoice>
  paymentMethod: Scalars['String']['output']
  paymentTransactions: Array<PaymentTransaction>
  /** Card details from Unzer (card payments only) */
  paymentTypeDetails?: Maybe<PaymentTypeDetails>
  priceBasis: Scalars['String']['output']
  reference: Scalars['String']['output']
  status: Scalars['String']['output']
  /** Total gross (decimal as string) */
  totalGross: Scalars['String']['output']
  /** Total net (decimal as string) */
  totalNet: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Order information for checkout */
export type OrderInput = {
  /** Currency code */
  currency: CurrencyEnum
  /** Optional note or reference text to show on the invoice */
  invoiceNote?: InputMaybe<Scalars['String']['input']>
  /** Invoice number (unique) */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
  /** Checkout invoices */
  invoices?: InputMaybe<Array<CheckoutInvoiceInput>>
  /** Invoice line items */
  lineItems?: InputMaybe<Array<InvoiceLineItemInput>>
  /** Order type */
  orderType: OrderTypeEnum
  /** Source basis used for checkout price calculations */
  priceBasis?: InputMaybe<PriceBasisEnum>
  /** Order reference (unique identifier) */
  reference: Scalars['String']['input']
  /** Service period (Leistungszeitraum) */
  servicePeriod?: InputMaybe<ServicePeriodInput>
  /** Total amount including VAT */
  totalGross?: InputMaybe<Scalars['String']['input']>
  /** Total amount excluding VAT */
  totalNet?: InputMaybe<Scalars['String']['input']>
}

/** Supported order statuses */
export enum OrderStatusEnum {
  /** Cancelled */
  Cancelled = 'cancelled',
  /** Chargedback */
  Chargedback = 'chargedback',
  /** Failed */
  Failed = 'failed',
  /** Fully Refunded */
  FullyRefunded = 'fully_refunded',
  /** Overpaid */
  Overpaid = 'overpaid',
  /** Paid */
  Paid = 'paid',
  /** Partially Refunded */
  PartiallyRefunded = 'partially_refunded',
  /** Pending */
  Pending = 'pending',
  /** Underpaid */
  Underpaid = 'underpaid',
}

/** Type of order */
export enum OrderTypeEnum {
  /** Badge order */
  BadgeOrder = 'BADGE_ORDER',
  /** Job order */
  JobOrder = 'JOB_ORDER',
  /** Ticket order */
  TicketOrder = 'TICKET_ORDER',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

/** Payment method information */
export type PaymentMethodInput = {
  /** Card payment details (required for type: card) */
  card?: InputMaybe<CardPaymentInput>
  /** Direct debit payment details (required for type: direct_debit) */
  debit?: InputMaybe<DirectDebitPaymentInput>
  /** URL to redirect after payment completion */
  returnUrl: Scalars['String']['input']
  /** Session ID for fraud prevention (used by BNPL payment methods) */
  sessionId?: InputMaybe<Scalars['String']['input']>
  /** Payment method type */
  type: PaymentMethodTypeEnum
}

/** Supported payment method types */
export enum PaymentMethodTypeEnum {
  /** Credit/Debit Card */
  Card = 'card',
  /** Direct Debit */
  Debit = 'debit',
  /** Pay by Invoice */
  Invoice = 'invoice',
  /** PayPal */
  Paypal = 'paypal',
}

/** A payment transaction */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction'
  /** Transaction amount (decimal as string) */
  amount: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  currency: Scalars['String']['output']
  id: Scalars['ID']['output']
  status: Scalars['String']['output']
  transactionType: Scalars['String']['output']
}

/** Card details from Unzer */
export type PaymentTypeDetails = {
  __typename?: 'PaymentTypeDetails'
  /** Account type (CREDIT, DEBIT) */
  account?: Maybe<Scalars['String']['output']>
  /** Card brand (e.g. VISA, MASTER) */
  brand?: Maybe<Scalars['String']['output']>
  /** Card holder name */
  cardHolder?: Maybe<Scalars['String']['output']>
  /** Card type (e.g. PLATINUM, CLASSIC) */
  cardType?: Maybe<Scalars['String']['output']>
  /** Card expiry date */
  expiryDate?: Maybe<Scalars['String']['output']>
  /** Masked card number */
  number?: Maybe<Scalars['String']['output']>
}

/** Source basis used for checkout price calculations */
export enum PriceBasisEnum {
  /** Gross-first checkout input */
  Gross = 'GROSS',
  /** Net-first checkout input */
  Net = 'NET',
}

export type PublicMutation = {
  __typename?: 'PublicMutation'
  notifications: NotificationMutations
  pong: Scalars['String']['output']
}

export type PublicQuery = {
  __typename?: 'PublicQuery'
  /** Returns the current user notifications feed */
  notifications: NotificationConnection
  ping: Scalars['String']['output']
}

export type PublicQueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  archivedStatus?: InputMaybe<ArchivedStatus>
  before?: InputMaybe<Scalars['String']['input']>
  categoryPrefix?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  readStatus?: InputMaybe<ReadStatus>
}

export type Query = {
  __typename?: 'Query'
  /** Find an order by reference */
  order?: Maybe<Order>
  /** Find orders by references */
  orders: Array<Order>
  public: PublicQuery
}

export type QueryOrderArgs = {
  reference: Scalars['String']['input']
}

export type QueryOrdersArgs = {
  references: Array<Scalars['String']['input']>
}

/** Read state filter for the notifications feed */
export enum ReadStatus {
  /** All notifications */
  All = 'ALL',
  /** Only read notifications */
  Read = 'READ',
  /** Only unread notifications */
  Unread = 'UNREAD',
}

/** Line item to refund */
export type RefundLineItemInput = {
  /** External ID of the debit line item to refund */
  externalId: Scalars['String']['input']
  /** Quantity to refund */
  quantity: Scalars['Int']['input']
}

/** Autogenerated input type of RefundMutation */
export type RefundMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Debit invoice number to refund */
  invoiceNumber: Scalars['String']['input']
  /** Line items to refund */
  lineItems?: InputMaybe<Array<RefundLineItemInput>>
  /** Reason for the refund */
  reason?: InputMaybe<RefundReasonEnum>
  /** Order reference */
  reference: Scalars['String']['input']
  /** Refund all remaining quantities */
  refundAll?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of RefundMutation. */
export type RefundMutationPayload = {
  __typename?: 'RefundMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Credit invoice number */
  creditInvoiceNumber?: Maybe<Scalars['String']['output']>
  /** Mutation errors */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** Whether the refund was successful */
  success: Scalars['Boolean']['output']
}

/** Reason for the refund */
export enum RefundReasonEnum {
  /** Cancellation refund */
  Cancellation = 'CANCELLATION',
  /** Correction refund */
  Correction = 'CORRECTION',
  /** Goodwill refund */
  Goodwill = 'GOODWILL',
}

/** Autogenerated input type of ResendInvoiceMutation */
export type ResendInvoiceMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Invoice number */
  invoiceNumber: Scalars['String']['input']
}

/** Autogenerated return type of ResendInvoiceMutation. */
export type ResendInvoiceMutationPayload = {
  __typename?: 'ResendInvoiceMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Mutation errors */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** Whether the invoice resend was enqueued */
  success: Scalars['Boolean']['output']
}

/** Service period date range (Leistungszeitraum) */
export type ServicePeriodInput = {
  /** Service period end date */
  endDate: Scalars['ISO8601Date']['input']
  /** Service period start date */
  startDate: Scalars['ISO8601Date']['input']
}

/** Autogenerated input type of UpdateCustomerEmailMutation */
export type UpdateCustomerEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Customer email address */
  email: Scalars['String']['input']
  /** Order reference */
  reference: Scalars['String']['input']
}

/** Autogenerated return type of UpdateCustomerEmailMutation. */
export type UpdateCustomerEmailMutationPayload = {
  __typename?: 'UpdateCustomerEmailMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Mutation errors */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** Whether the customer email update succeeded */
  success: Scalars['Boolean']['output']
}

export type ArchiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ArchiveMutation = {
  __typename?: 'Mutation'
  public: {
    __typename?: 'PublicMutation'
    notifications: {
      __typename?: 'NotificationMutations'
      archive: Array<{ __typename?: 'Notification'; id: string; readAt?: string | null; archivedAt?: string | null }>
    }
  }
}

export type MarkAllAsReadMutationVariables = Exact<{ [key: string]: never }>

export type MarkAllAsReadMutation = {
  __typename?: 'Mutation'
  public: {
    __typename?: 'PublicMutation'
    notifications: { __typename?: 'NotificationMutations'; markAllAsRead: { __typename?: 'MarkAllAsReadPayload'; unreadCount: number } }
  }
}

export type MarkAsReadMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type MarkAsReadMutation = {
  __typename?: 'Mutation'
  public: {
    __typename?: 'PublicMutation'
    notifications: {
      __typename?: 'NotificationMutations'
      markAsRead: Array<{ __typename?: 'Notification'; id: string; readAt?: string | null; archivedAt?: string | null }>
    }
  }
}

export type MarkAsUnreadMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type MarkAsUnreadMutation = {
  __typename?: 'Mutation'
  public: {
    __typename?: 'PublicMutation'
    notifications: {
      __typename?: 'NotificationMutations'
      markAsUnread: Array<{ __typename?: 'Notification'; id: string; readAt?: string | null; archivedAt?: string | null }>
    }
  }
}

export type UnarchiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type UnarchiveMutation = {
  __typename?: 'Mutation'
  public: {
    __typename?: 'PublicMutation'
    notifications: {
      __typename?: 'NotificationMutations'
      unarchive: Array<{ __typename?: 'Notification'; id: string; readAt?: string | null; archivedAt?: string | null }>
    }
  }
}

export type NotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  readStatus?: InputMaybe<ReadStatus>
  archivedStatus?: InputMaybe<ArchivedStatus>
  categoryPrefix?: InputMaybe<Scalars['String']['input']>
}>

export type NotificationsQuery = {
  __typename?: 'Query'
  public: {
    __typename?: 'PublicQuery'
    notifications: {
      __typename?: 'NotificationConnection'
      unreadCount: number
      availableCategories: Array<string>
      nodes: Array<{
        __typename?: 'Notification'
        id: string
        uuid: string
        category: string
        partnerCompanySlug?: string | null
        schemaVersion: string
        readAt?: string | null
        archivedAt?: string | null
        createdAt: string
        content: Array<{
          __typename?: 'NotificationBlock'
          type: string
          fields: Array<{ __typename?: 'BlockField'; name: string; value: string }>
        }>
      }>
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null }
    }
  }
}

export const ArchiveDocument = gql`
  mutation Archive($ids: [ID!]!) {
    public {
      notifications {
        archive(ids: $ids) {
          id
          readAt
          archivedAt
        }
      }
    }
  }
`

/**
 * __useArchiveMutation__
 *
 * To run a mutation, you first call `useArchiveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ArchiveMutation, ArchiveMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveMutation, ArchiveMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<ArchiveMutation, ArchiveMutationVariables>(ArchiveDocument, options)
}
export type ArchiveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchiveMutation, ArchiveMutationVariables>
export const MarkAllAsReadDocument = gql`
  mutation MarkAllAsRead {
    public {
      notifications {
        markAllAsRead {
          unreadCount
        }
      }
    }
  }
`

/**
 * __useMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkAllAsReadMutation();
 */
export function useMarkAllAsReadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>(MarkAllAsReadDocument, options)
}
export type MarkAllAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkAllAsReadMutation,
  MarkAllAsReadMutationVariables
>
export const MarkAsReadDocument = gql`
  mutation MarkAsRead($ids: [ID!]!) {
    public {
      notifications {
        markAsRead(ids: $ids) {
          id
          readAt
          archivedAt
        }
      }
    }
  }
`

/**
 * __useMarkAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkAsReadMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkAsReadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkAsReadMutation, MarkAsReadMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkAsReadMutation, MarkAsReadMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<MarkAsReadMutation, MarkAsReadMutationVariables>(MarkAsReadDocument, options)
}
export type MarkAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkAsReadMutation,
  MarkAsReadMutationVariables
>
export const MarkAsUnreadDocument = gql`
  mutation MarkAsUnread($ids: [ID!]!) {
    public {
      notifications {
        markAsUnread(ids: $ids) {
          id
          readAt
          archivedAt
        }
      }
    }
  }
`

/**
 * __useMarkAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkAsUnreadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsUnreadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkAsUnreadMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkAsUnreadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkAsUnreadMutation, MarkAsUnreadMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkAsUnreadMutation, MarkAsUnreadMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<MarkAsUnreadMutation, MarkAsUnreadMutationVariables>(MarkAsUnreadDocument, options)
}
export type MarkAsUnreadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkAsUnreadMutation,
  MarkAsUnreadMutationVariables
>
export const UnarchiveDocument = gql`
  mutation Unarchive($ids: [ID!]!) {
    public {
      notifications {
        unarchive(ids: $ids) {
          id
          readAt
          archivedAt
        }
      }
    }
  }
`

/**
 * __useUnarchiveMutation__
 *
 * To run a mutation, you first call `useUnarchiveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnarchiveMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useUnarchiveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UnarchiveMutation, UnarchiveMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnarchiveMutation, UnarchiveMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UnarchiveMutation, UnarchiveMutationVariables>(UnarchiveDocument, options)
}
export type UnarchiveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UnarchiveMutation,
  UnarchiveMutationVariables
>
export const NotificationsDocument = gql`
  query Notifications($first: Int, $after: String, $readStatus: ReadStatus, $archivedStatus: ArchivedStatus, $categoryPrefix: String) {
    public {
      notifications(
        first: $first
        after: $after
        readStatus: $readStatus
        archivedStatus: $archivedStatus
        categoryPrefix: $categoryPrefix
      ) {
        nodes {
          id
          uuid
          category
          partnerCompanySlug
          schemaVersion
          content {
            type
            fields {
              name
              value
            }
          }
          readAt
          archivedAt
          createdAt
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        unreadCount
        availableCategories
      }
    }
  }
`

/**
 * __useNotificationsQuery__
 *
 * To run a query within a Vue component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   readStatus: // value for 'readStatus'
 *   archivedStatus: // value for 'archivedStatus'
 *   categoryPrefix: // value for 'categoryPrefix'
 * });
 */
export function useNotificationsQuery(
  variables:
    | NotificationsQueryVariables
    | VueCompositionApi.Ref<NotificationsQueryVariables>
    | ReactiveFunction<NotificationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options)
}
export function useNotificationsLazyQuery(
  variables:
    | NotificationsQueryVariables
    | VueCompositionApi.Ref<NotificationsQueryVariables>
    | ReactiveFunction<NotificationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options)
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  NotificationsQuery,
  NotificationsQueryVariables
>
